import { CategoryColor } from '@models/TagCategory.model';

import { CustomOption, Circle } from './CategoryColorBadge.styles';

interface ICategoryColorBadge {
  color: CategoryColor;
  name?: string;
}

export const CategoryColorBadge = ({ color, name }: ICategoryColorBadge) => {
  return (
    <CustomOption>
      <Circle color={color} />
      {name}
    </CustomOption>
  );
};
